import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityLogItemIcon',
  props: {
    iconInfo: null
  },
  setup(__props: any) {

const props = __props as {
  iconInfo: {
    icon: string
    color: string
    topPadding: number
    bottomPadding: number
    leftPadding: number
    rightPadding: number
  }
}



const iconStyle = computed(() => ({
  'padding-top': `${props.iconInfo.topPadding}px`,
  'padding-bottom': `${props.iconInfo.bottomPadding}px`,
  'padding-left': `${props.iconInfo.leftPadding}px`,
  'padding-right': `${props.iconInfo.rightPadding}px`,
}))

return { __sfc: true,props, iconStyle }
}

})